import React from "react";
import { ShieldCheck } from "lucide-react";
import { usePageMeta } from "@/lib/seo";
import { useLegal } from "@/lib/legal";
import LegalCards from "@/components/legal/LegalCards";
import LegalSections from "@/components/legal/LegalSections";
import LegalLegacy from "@/pages/LegalLegacy";

const h1 = "font-display font-bold text-4xl sm:text-5xl lg:text-6xl text-ink mt-3 mb-6 tracking-tight";

const Impressum = ({ d }) => (
  <>
    <p className="eyebrow">Rechtliches</p>
    <h1 className={h1}>Impressum</h1>
    <p className="text-base text-dim leading-relaxed max-w-2xl" data-testid="impressum-intro">{d.intro}</p>
    <p className="text-xs text-faint mt-4 mb-10" data-testid="impressum-basis">{d.basis}</p>
    <LegalCards cards={d.cards} />
    <div className="mt-14"><LegalSections sections={d.sections} page="impressum" /></div>
  </>
);

const Datenschutz = ({ d }) => (
  <>
    <p className="eyebrow">{d.title}</p>
    <h1 className={h1}>Datenschutz</h1>
    <p className="text-base text-dim leading-relaxed max-w-3xl" data-testid="datenschutz-intro">{d.intro}</p>
    <ul className="grid sm:grid-cols-3 gap-3 mt-10 mb-12" data-testid="datenschutz-highlights">
      {d.highlights.map((h) => (
        <li key={h} className="rounded-2xl border border-line bg-surface px-5 py-4 flex items-start gap-3 text-sm text-ink font-medium leading-snug">
          <ShieldCheck size={17} className="text-brand shrink-0 mt-0.5" /> {h}
        </li>
      ))}
    </ul>
    <LegalSections sections={d.sections} page="datenschutz" />
  </>
);

export default function Legal({ page }) {
  usePageMeta(page === "impressum" ? "Impressum" : "Datenschutz", null);
  const { data, error } = useLegal();
  if (error === "missing") return <LegalLegacy page={page} />;
  return (
    <div data-testid={`legal-page-${page}`} className="pt-28 md:pt-36 pb-24 mx-auto px-5 sm:px-8 max-w-5xl">
      {error && <p className="text-sm text-dim" data-testid="legal-load-error">Die Rechtstexte konnten gerade nicht geladen werden. Bitte laden Sie die Seite neu.</p>}
      {!data && !error && <div className="w-7 h-7 border-2 border-line border-t-brand rounded-full animate-spin" data-testid="legal-loading" />}
      {data && (page === "impressum" ? <Impressum d={data.impressum} /> : <Datenschutz d={data.datenschutz} />)}
    </div>
  );
}
